import type { LinkHref } from "@octopusdeploy/portal-routes";
import { resolvePathWithSpaceId } from "@octopusdeploy/portal-routes";
import type { History } from "history";
import * as React from "react";
import type { RouteComponentProps } from "react-router";
import { Redirect, withRouter } from "react-router";
import { isPageUrl } from "../InternalLink/isPageUrl";
import { usePageUrlResolver } from "../usePageUrlResolver";
type LocationDescriptor = History.LocationDescriptor;
interface InternalRedirectComponentProps {
    to: LocationDescriptor | LinkHref;
    push?: boolean;
    exact?: boolean;
    from?: string;
}
type InternalRedirectProps = InternalRedirectComponentProps & RouteComponentProps<{
    spaceId: string;
}>;
const InternalRedirect: React.SFC<InternalRedirectProps> = (props: InternalRedirectProps) => {
    const pageUrlResolver = usePageUrlResolver();
    const resolvedPath = isPageUrl(props.to) ? pageUrlResolver.resolve(props.to) : resolvePathWithSpaceId(props.to, props.match.params.spaceId);
    /* eslint-disable react/forbid-elements */
    return <Redirect from={props.from} to={resolvedPath} push={props.push} exact={props.exact}/>;
};
InternalRedirect.displayName = "InternalRedirect"
const EnhancedInternalRedirect = withRouter(InternalRedirect);
const InternalRedirectWithHistory: React.SFC<InternalRedirectProps> = (props) => <EnhancedInternalRedirect push={true} {...props}/>;
InternalRedirectWithHistory.displayName = "InternalRedirectWithHistory"
export default EnhancedInternalRedirect;
export { InternalRedirectWithHistory };
